import { render } from "./WPatientEditionForm.vue?vue&type=template&id=5a66c44d&scoped=true&ts=true"
import script from "./WPatientEditionForm.vue?vue&type=script&lang=ts"
export * from "./WPatientEditionForm.vue?vue&type=script&lang=ts"

import "./WPatientEditionForm.vue?vue&type=style&index=0&id=5a66c44d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a66c44d"]])

export default __exports__